import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import ApiService from '../../../Services/ApiService';
import c from '../../../Components/AuthLayout/authContent.module.less';

// In production the SPA is served under /accounts (see ApiService.getPrefix).
const getPrefix = () => (process.env.NODE_ENV !== 'development' ? '/accounts' : '');

// Public landing for the tokenized invite-accept email link. The token in the
// URL authenticates the move, so the user does not need to log in first (they
// often can't — their current org is disabled).
//
// The accept POST fires only on an explicit button click, NOT on page load:
// the invite is single-use, and email-security scanners / link previews that
// merely fetch the URL would otherwise consume it before the human clicks,
// leaving the real user with a dead ("expired") link.
const AcceptInvitePage = () => {
  const [submitting, setSubmitting] = useState(false);
  const token = new URLSearchParams(window.location.search).get('invite_token');

  const acceptInvite = () => {
    if (!token || submitting) {
      return;
    }

    setSubmitting(true);
    ApiService.acceptInviteByToken({ token })
      .then(() => window.location.assign(`${getPrefix()}/`))
      .catch(() => window.location.assign(`${getPrefix()}/invalid-token`));
  };

  return (
    <>
      <Helmet>
        <title>Accept invitation</title>
      </Helmet>
      <h1 className={c.title}>Accept your invitation</h1>
      <p className={c.text} test-id="page-title">
        You have been invited to move to a new organization.
      </p>
      <div className={c.actions}>
        <button
          type="button"
          className={c.btnPrimary}
          onClick={acceptInvite}
          disabled={!token || submitting}
          test-id="accept-invite-button"
        >
          {submitting ? 'Accepting…' : 'Accept'}
        </button>
      </div>
    </>
  );
};

export default AcceptInvitePage;
